function nonCharacterSpecial(str) {
   // eslint-disable-next-line
   var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
   
   if(format.test(str)){
      return true;
   } else {
      return false;
   }
}

function validateEmails(str) {
   // eslint-disable-next-line
   var format = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
   
   if(format.test(str)){
      return true;
   } else {
      return false;
   }
}

export {
   nonCharacterSpecial,
   validateEmails
}